module.exports = __webpack_public_path__ + "img/winners-rafiki.e1e7e060.svg";